import { render, staticRenderFns } from "./CompanyAssetCreateEditModal.vue?vue&type=template&id=520451b2"
import script from "./CompanyAssetCreateEditModal.vue?vue&type=script&lang=js"
export * from "./CompanyAssetCreateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports